import {Injectable} from "@angular/core";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


@Injectable()

export class HeaderProvider
{
//    constructor(private serviceFirestore: firestoreService) {
//    }
//    
//    getOperatingProfile()
//    {
//        return this.serviceFirestore.getDocumentObject(this.serviceFirestore.firestore.collection("ORG_MST").doc(this.serviceFirestore.auth.getSession().ORG_ID).collection("OPR_LIST"), this.serviceFirestore.auth.getSession().OPR_ID)
//    }
//    
//    getOraganizationProfile()
//    {
//        return this.serviceFirestore.getDocumentObject(this.serviceFirestore.firestore.collection("ORG_MST"), this.serviceFirestore.auth.getSession().ORG_ID)
//    }
    
}